import { Deserializable } from './deserializable';
import { BaseModel } from './base.model';

export class DataScopeModel extends BaseModel implements Deserializable {

  // columns
  id: number;
  name: string;
  title: any;
  description: string;
  active: boolean;
  dimensions: Array<string>;
  counts: any;
  template: any;
  businessunit: any;

  deserialize(input: any): this {
    Object.assign(this, input);
    this.loaded = true;
    return this;
  }

  hasDimension(dimension: string): boolean {
    return Array.isArray(this.dimensions) && this.dimensions.indexOf(dimension) !== -1;
  }

  get translated_title(): string {
    const lang = this.transloco.getActiveLang();
    return (this.title !== null) ? this.title[lang.toUpperCase()] : this.name;
  }

}
